import React from 'react';
import { Route, Switch } from 'react-router-dom';

import home from '../../../Page';
import Denied from '../../../Page/denied';

import SecurityKey from '../../../Page/SecurityKey/index';
import SecurityProfile from '../../../Page/SecurityProfile/index';
import SecurityGroup from '../../../Page/SecurityGroup/index';

import Users from '../../../Page/Users/index';
import Organs from '../../../Page/Orgao/index';
import Cidade from '../../../Page/Cidade/index';
import GeologiaShapeFileCidadeArea from '../../../Page/GeologiaShapeFileCidadeArea/index';
import GeologiaShapeFileEstadoArea from '../../../Page/GeologiaShapeFileEstadoArea/index';
import GeologiaShapeFileCavernas from '../../../Page/GeologiaShapeFileCavernas/index';
import GeologiaShapeFileProtecaoIntegral from '../../../Page/GeologiaShapeFileProtecaoIntegral/index';
import GeologiaShapeFileQuilombolas from '../../../Page/GeologiaShapeFileQuilombolas/index';
import GeologiaShapeFileSitiosArqueologicos from '../../../Page/GeologiaShapeFileSitiosArqueologicos/index';
import GeologiaShapeFileTerrasIndigenas from '../../../Page/GeologiaShapeFileTerrasIndigenas/index';
import GeologiaShapeFileUsoSustentavel from '../../../Page/GeologiaShapeFileUsoSustentavel/index';
import Estado from '../../../Page/Estado/index';
import Clima from '../../../Page/Clima/index';
import Geologia from '../../../Page/Geologia/index';
import GeologiaShapeFile from '../../../Page/GeologiaShapeFile/index';
import GeologiaShapeFileEstado from '../../../Page/GeologiaShapeFileEstado/index';
import GeologiaShapeFileBrasil from '../../../Page/GeologiaShapeFileBrasil/index';

import Requerimento from '../../../Page/Requerimento/index';
import RequerimentoEvento from '../../../Page/RequerimentoEvento/index';
import RequerimentoFase from '../../../Page/RequerimentoFase/index';
import GeometryShapeRequerimento from '../../../Page/RequerimentoShapeFile/index';
import Substancia from '../../../Page/Substancia/index';
import SubstanciaUso from '../../../Page/SubstanciaUso/index';
import RequerimentoSyncCity from '../../../Page/RequerimentoSyncCity/index';

import MeusRequerimentos from '../../../Page/MeusRequerimentos/index';
import MeusBuffers from '../../../Page/MeusBuffers/index';

import Grupo from '../../../Page/Grupo/index';
import AspectosFisiograficos from '../../../Page/AspectosFisiograficos/index';
import LocalizacaoAcessos from '../../../Page/LocalizacaoAcessos/index';
import MeioSocioEconomico from '../../../Page/MeioSocioEconomico/index';

import MeioAmbienteClasse from '../../../Page/MeioAmbienteClasse/index';
import MeioAmbienteDivisao from '../../../Page/MeioAmbienteDivisao/index';
import MeioAmbienteGrupo from '../../../Page/MeioAmbienteGrupo/index';
import MeioAmbienteAreas from '../../../Page/MeioAmbienteAreas/index';
import MeioAmbienteTipologia from '../../../Page/MeioAmbienteTipologia/index';
import MeioAmbienteEnquadramento from '../../../Page/MeioAmbienteEnquadramento/index';
import Processos from '../../../Page/Processos/index';

import ShapeGeologies from '../../../Page/Shapes/shapeGeologies';
import ShapeGeologiesEstado from '../../../Page/Shapes/shapeGeologiesState';
import ShapeGeologiesBrasil from '../../../Page/Shapes/shapeGeologiesBrazil';
import RequirementsShapefile from '../../../Page/Shapes/shapeRequirements';
import ShapeGeologiesCidadeArea from '../../../Page/Shapes/shapeGeologiesCidadeArea';
import ShapeGeologiesEstadoArea from '../../../Page/Shapes/shapeGeologiesEstadoArea';
import ShapeGeologiesCavernas from '../../../Page/Shapes/shapeGeologiesCavernas';
import ShapeGeologiesProtecaoIntegral from '../../../Page/Shapes/shapeGeologiesProtecaoIntegral';
import ShapeGeologiesQuilombolas from '../../../Page/Shapes/shapeGeologiesQuilombolas';
import ShapeGeologiesSitiosArqueologicos from '../../../Page/Shapes/shapeGeologiesSitiosArqueologicos';
import ShapeGeologiesTerrasIndigenas from '../../../Page/Shapes/shapeGeologiesTerrasIndigenas';
import ShapeGeologiesUsoSustentavel from '../../../Page/Shapes/shapeGeologiesUsoSustentavel';
import DiarioOficial from '../../../Page/Shapes/shapeGeologies';

import Chat from '../../../Page/Chat';


import map from '../../../Page/ArcGis/mapArcGis';
import map2 from '../../../Page/ArcGis/mapArcGis2';

export default () => (
  <Switch>
    <Route path="/forms/home" component={home} />
    <Route path="/forms/denied" component={Denied} />
    
    <Route path="/forms/chat" component={Chat} />

    <Route path="/forms/securityKey" component={SecurityKey} />
    <Route path="/forms/securityProfile" component={SecurityProfile} />
    <Route path="/forms/securityGroup" component={SecurityGroup} />

    <Route path="/forms/users" component={Users} />

    <Route path="/forms/organs" component={Organs} />   
    
    <Route path="/forms/cities/geologyShapefileCidadeArea" component={GeologiaShapeFileCidadeArea}  />
    <Route path="/forms/cities" component={Cidade}  />
        
    <Route path="/forms/states/geologyShapefileEstadoArea" component={GeologiaShapeFileEstadoArea}  />
    <Route path="/forms/states" component={Estado}  />

    <Route path="/forms/climates" component={Clima}  />
    
    <Route path="/forms/geologies/geologyShapefile" component={GeologiaShapeFile}  />
    <Route path="/forms/geologies/geologyShapefileState" component={GeologiaShapeFileEstado}  />
    <Route path="/forms/geologies/geologyShapefileBrazil" component={GeologiaShapeFileBrasil}  />
    <Route path="/forms/geologies/geologyShapefileCavernas" component={GeologiaShapeFileCavernas}  />
    <Route path="/forms/geologies/geologyShapefileProtecaoIntegral" component={GeologiaShapeFileProtecaoIntegral}  />
    <Route path="/forms/geologies/geologyShapefileQuilombolas" component={GeologiaShapeFileQuilombolas}  />
    <Route path="/forms/geologies/geologyShapefileSitiosArqueologicos" component={GeologiaShapeFileSitiosArqueologicos}  />
    <Route path="/forms/geologies/geologyShapefileTerrasIndigenas" component={GeologiaShapeFileTerrasIndigenas}  />
    <Route path="/forms/geologies/geologyShapefileUsoSustentavel" component={GeologiaShapeFileUsoSustentavel}  />
    
    <Route path="/forms/geologies" component={Geologia}  />
    
    <Route path="/forms/requirements/events" component={RequerimentoEvento}  />
    <Route path="/forms/requirements/phase" component={RequerimentoFase}  />
    <Route path="/forms/requirements/geometryShapeRequerimento" component={GeometryShapeRequerimento}  />
    <Route path="/forms/requirements/substance" component={Substancia}  />
    <Route path="/forms/requirements/substanceUse" component={SubstanciaUso}  />
    <Route path="/forms/requirements/sync" component={RequerimentoSyncCity}  />
    
    <Route path="/forms/requirements" component={Requerimento}  />

    <Route path="/forms/myrequirements" component={MeusRequerimentos}  />
    <Route path="/forms/mybuffers" component={MeusBuffers}  />

    


    <Route path="/forms/proccess/:proccess" component={Processos} />
    <Route path="/forms/proccess" component={Processos}  />
    


    <Route path="/forms/groups" component={Grupo}  />
    <Route path="/forms/aspectosFisiograficos" component={AspectosFisiograficos}  />
    <Route path="/forms/localizacaoAcessos" component={LocalizacaoAcessos}  />
    <Route path="/forms/meioSocioEconomicos" component={MeioSocioEconomico}  />
    
    <Route path="/forms/meioAmbienteClasse" component={MeioAmbienteClasse}  />
    <Route path="/forms/meioAmbienteDivisao" component={MeioAmbienteDivisao}  />
    <Route path="/forms/meioAmbienteGrupo" component={MeioAmbienteGrupo}  />
    <Route path="/forms/meioAmbienteAreas" component={MeioAmbienteAreas}  />
    <Route path="/forms/meioAmbienteTipologia" component={MeioAmbienteTipologia}  />
    <Route path="/forms/enquadramento" component={MeioAmbienteEnquadramento}  />

    <Route path="/forms/geologyShapefile" component={ShapeGeologies}  />
    <Route path="/forms/geologyShapefileState" component={ShapeGeologiesEstado}  />
    <Route path="/forms/geologyShapefileBrazil" component={ShapeGeologiesBrasil}  />

    <Route path="/forms/requirementsShapefile" component={RequirementsShapefile}  />
    <Route path="/forms/geologyShapefileCidadeArea" component={ShapeGeologiesCidadeArea}  />


    <Route path="/forms/geologyShapefileEstadoArea" component={ShapeGeologiesEstadoArea}  />
    <Route path="/forms/geologyShapefileCavernas" component={ShapeGeologiesCavernas}  />
    <Route path="/forms/geologyShapefileProtecaoIntegral" component={ShapeGeologiesProtecaoIntegral}  />
    <Route path="/forms/geologyShapefileQuilombolas" component={ShapeGeologiesQuilombolas}  />
    <Route path="/forms/geologyShapefileSitiosArqueologicos" component={ShapeGeologiesSitiosArqueologicos}  />
    <Route path="/forms/geologyShapefileTerrasIndigenas" component={ShapeGeologiesTerrasIndigenas}  />
    <Route path="/forms/geologyShapefileUsoSustentavel" component={ShapeGeologiesUsoSustentavel}  />


    <Route path="/forms/diarioOficial" component={DiarioOficial}  />
    
    <Route path="/forms/map" component={map} />
    <Route path="/forms/map2" component={map2} />
  </Switch>
);
